import { TIMESHEET_STATUS } from "@/time-tracking/types/Timesheet";
import { Tag } from "antd";

const TimesheetStatusTag = ({
  status,
}: {
  status: keyof typeof TIMESHEET_STATUS;
}) => {
  if (status === "PENDING") {
    return <Tag color="gold">Pending Approval</Tag>;
  }

  if (status === "APPROVED") {
    return <Tag color="success">Approved</Tag>;
  }

  return <Tag>{status}</Tag>;
};

export default TimesheetStatusTag;
